
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-6'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - STYLING {{ $route.query.styling_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.styling_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='styling_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'styling_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.stylingTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.stylingTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='styling_sub_title'>서브 타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'styling_sub_title'
                maxLength="100"
                placeholder = "서브 타이틀을 입력해 주세요.(100자 이내)"
                v-model="formData.stylingSubTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.stylingSubTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='styling_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="styling_status"
                v-model="formData.stylingStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='styling_main_status'>메인 노출<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="styling_main_status"
                v-model="formData.stylingMainStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">메인 노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1080 x 1080px</p>
                <label for='styling_main_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.styling_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'styling_main_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_Square">
                  <img
                    :src="formData.stylingMainImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.stylingMainImageURL"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.stylingMainImageURLError}}</p>
              </div>
            </div>
          </div>

          <div class="Admin_editorBox_BoxWrap">
            <div class="Admin_editorBox_BoxTit">
              PC용 에디터
              <span> (스크린 최소 사이즈 기준 1200px)</span>
            </div>
            <custom-textarea
              v-model="formData.stylingEditor"
              :id="'top_banner_editor'"
            />
          </div>

          <div class="Admin_editorBox_BoxWrap">
            <div class="Admin_editorBox_BoxTit">
              모바일용 에디터
              <span> (스크린 최소 사이즈 기준 480px)</span>
            </div>
            <custom-textarea
              v-model="formData.stylingEditorMobile"
              :id="'top_banner_mobile_editor'"
              style="width:480px;"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import {
  get_styling_one,
  insert_styling,
  update_styling
} from '../../ETC/Axios.vue'
import {
  editor_init_data,
  editor_init_data_mo
} from '../../ETC/Variable.vue'

export default {
  name: 'AdminStylingManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        stylingTitle: '',
        stylingSubTitle: '',
        stylingStatus: 1,
        stylingMainStatus: 2,
        stylingMainImage: '',
        stylingMainImageURL: '',
        stylingEditor: '',
        stylingEditorMobile: ''
      }),
      errorData: ref({
        stylingTitleError: '',
        stylingSubTitleError: '',
        stylingMainImageURLError: ''
      }),
      statusData: ref({
        editorInitData: editor_init_data,
        editorInitDataMo: editor_init_data_mo,
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.stylingMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.stylingMainImageURL = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.stylingTitle === '') {
        this.errorData.stylingTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.stylingTitleError = ''
      }
      if (this.formData.stylingSubTitle === '') {
        this.errorData.stylingSubTitleError = '서브 타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.stylingSubTitleError = ''
      }
      if (this.formData.stylingMainImageURL === '') {
        this.errorData.stylingMainImageURLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.stylingMainImageURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.styling_ID === undefined) {
          insert_styling(
            this.formData.stylingTitle,
            this.formData.stylingSubTitle,
            this.formData.stylingMainImage,
            this.formData.stylingEditor,
            this.formData.stylingEditorMobile,
            this.formData.stylingStatus,
            this.formData.stylingMainStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminStylingManagement'
          })
        } else {
          update_styling(
            this.$route.query.styling_ID,
            this.formData.stylingTitle,
            this.formData.stylingSubTitle,
            this.formData.stylingMainImage,
            this.formData.stylingEditor,
            this.formData.stylingEditorMobile,
            this.formData.stylingStatus,
            this.formData.stylingMainStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminStylingManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.styling_ID !== undefined) {
      get_styling_one(this.$route.query.styling_ID).then((result) => {
        this.formData.stylingTitle = result[0].styling_title
        this.formData.stylingSubTitle = result[0].styling_sub_title
        this.formData.stylingStatus = result[0].styling_status
        this.formData.stylingMainStatus = result[0].styling_main_status
        this.formData.stylingMainImageURL = result[0].styling_main_image
        this.formData.stylingEditor = result[0].styling_editor
        this.formData.stylingEditorMobile = result[0].styling_editor_mobile
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminStylingManagementAdd.vue